import { GetListsRequestSortParamsI } from "@/api/routes/list";
import { EmailDraftI } from "@/components/modules/email-templates-sidebar/interfaces";
import { UserI } from "@/interfaces/user";

const USER_KEY = "user";

// const CAMPAIGNS_KEY = "campaigns";

const DIALER_GLOBAL_TWILIO_TOKEN_UPDATED_AT =
  "dialer_global_twilio_token_updated_at";

/**
 * Should followup by list id
 */
const LIST_SORTING = "list_sorting";

const ACCOUNT_DETAILS_NOTE = "account_details_note";

const EMAIL_LOCAL_DRAFTS_BY_CALL_ID = "email_local_drafts_by_call_id";

const LIST_WORKSPACE_DIMENSIONS_WARNING_SHOWN =
  "list_workspace_dimensions_warning_shown";

const LAST_NETWORK_ERROR_AT = "last_network_error_at";

// Works ONLY in the browser
export class SessionStorage {
  /**
   * Cache Get User API response
   */
  get user(): UserI | undefined {
    const userAsString = window.sessionStorage.getItem(USER_KEY) as string;

    try {
      return JSON.parse(userAsString);
    } catch {
      // TODO datadog
      console.log("Failed to parse user");
      console.log(userAsString);
      return undefined;
    }
  }
  set user(data: UserI) {
    window.sessionStorage.setItem(USER_KEY, JSON.stringify(data));
  }

  /**
   * Cache Get Campaigns available campaigns. Commenting out, as it's not used in any way for now.
   */
  // get campaigns(): Array<CampaignV3I> | undefined {
  //   const campaignsAsString = window.sessionStorage.getItem(
  //     CAMPAIGNS_KEY
  //   ) as string;
  //
  //   try {
  //     return JSON.parse(campaignsAsString);
  //   } catch (e) {
  //     // TODO datadog
  //     console.log("Failed to parse user");
  //     console.log(campaignsAsString);
  //     return undefined;
  //   }
  // }
  // set campaigns(data: Array<CampaignV3I>) {
  //   window.sessionStorage.setItem(CAMPAIGNS_KEY, JSON.stringify(data));
  // }

  get dialerGlobalTwilioTokenUpdatedAt(): string | undefined | null {
    return window.sessionStorage.getItem(DIALER_GLOBAL_TWILIO_TOKEN_UPDATED_AT);
  }
  set dialerGlobalTwilioTokenUpdatedAt(date: string) {
    window.sessionStorage.setItem(DIALER_GLOBAL_TWILIO_TOKEN_UPDATED_AT, date);
  }

  get emailLocalDraftsByCallId(): Record<string, EmailDraftI> {
    return JSON.parse(
      window.sessionStorage.getItem(EMAIL_LOCAL_DRAFTS_BY_CALL_ID) as string
    );
  }
  set emailLocalDraftsByCallId(data: Record<string, EmailDraftI>) {
    window.sessionStorage.setItem(
      EMAIL_LOCAL_DRAFTS_BY_CALL_ID,
      JSON.stringify(data)
    );
  }

  getAccountDetailsNote(accountId: string): string | undefined | null {
    return window.sessionStorage.getItem(
      `${ACCOUNT_DETAILS_NOTE}-${accountId}`
    );
  }
  setAccountDetailsNote(accountId: string, note: string) {
    window.sessionStorage.setItem(`${ACCOUNT_DETAILS_NOTE}-${accountId}`, note);
  }

  getListSorting(listId: string): GetListsRequestSortParamsI {
    try {
      return JSON.parse(
        window.sessionStorage.getItem(`${LIST_SORTING}-${listId}`) as string
      );
    } catch {
      return {};
    }
  }

  setListSorting(
    listId: string,
    sortParams?: GetListsRequestSortParamsI
  ): void {
    window.sessionStorage.setItem(
      `${LIST_SORTING}-${listId}`,
      JSON.stringify(sortParams || {})
    );
  }

  get listWorkspaceDimensionsWarningShown(): boolean {
    return (
      window.sessionStorage.getItem(LIST_WORKSPACE_DIMENSIONS_WARNING_SHOWN) ===
      "true"
    );
  }
  set listWorkspaceDimensionsWarningShown(value: boolean) {
    window.sessionStorage.setItem(
      LIST_WORKSPACE_DIMENSIONS_WARNING_SHOWN,
      value.toString()
    );
  }

  get lastNetworkErrorAt(): string | undefined | null {
    return window.sessionStorage.getItem(LAST_NETWORK_ERROR_AT);
  }
  set lastNetworkErrorAt(date: string) {
    window.sessionStorage.setItem(LAST_NETWORK_ERROR_AT, date);
  }

  clear() {
    window.sessionStorage.clear();
  }
}
